module.exports = __webpack_public_path__ + "img/buddy_eyes-01.33613c21.svg";